export class VideosEnvironment {
  public static getName = () => 'benzinga-videos';
  public static getEnvironment = (env: Record<string, string>) => ({
    localYoutubeKey: env.localYoutubeKey ?? 'localyoutube_z95MIILMf8saQLmWBiAFOGuLK3IiQ1',
    toolsUrl: new URL(env.toolsUrl ?? 'https://www.benzinga.com/lavapress/api/'),
    url: new URL(env.url ?? 'https://www.benzinga.com/'),
  });
}
